export const personalAccident_LANGUAGE = {
  personalAccident_shelf_plan_listing_title: "Shelf Plans",
  personalAccident_shelf_plan_listing_add: "Add",
  shelf_plans_list_action_bar_search: "Search",
  personalAccident_shelf_plan_name: "Name",
  personalAccident_shelf_plan_product_name: "Product Name",
  personalAccident_shelf_plan_takaful_provider: "Takaful Provider",
  personalAccident_shelf_plan_type: "Type",
  personalAccident_shelf_price_type: "Price Type",
  personalAccident_shelf_plan_members: "Members",

  personalAccident_shelf_plan_about_this_plan_heading: "Heading",
  personalAccident_shelf_plan_about_this_plan_video_url: "Video URL",
  personalAccident_shelf_plan_add_about_this_plan_label: "Heading",
  personalAccident_shelf_plan_add_about_this_plan_placeholder: "Enter Heading",
  personalAccident_shelf_plan_add_about_this_plan_label_required_err: "Heading is required",
  personalAccident_shelf_plan_add_about_this_plan_label_length_err: "Heading should be under 50 characters",
  personalAccident_shelf_plan_add_about_this_plan_description_length_err: "Description should be under 500 characters",

  personalAccident_shelf_plan_add_about_this_plan_description_label: "Description",
  personalAccident_shelf_plan_add_about_this_plan_label_description_required_err: "Description is required",
  personalAccident_shelf_plan_add_about_this_plan_label_description_length_err: "Description should be under 50 characters",

  personalAccident_shelf_plan_add_about_this_plan_video_url_label: "Video URL",
  personalAccident_shelf_plan_add_about_this_plan_video_url_placeholder: "Enter Website url",

  personalAccident_shelf_plan_add_about_this_plan_video_url_required: "Video URL is required",

  personalAccident_shelf_plans_add_info_title: "Information",
  personalAccident_shelf_plans_add_price_setup_title: "Price Setup",
  personalAccident_shelf_plans_add_price_unsaved_data_warning: "You have unsaved data here. Do you want to continue?",
  personalAccident_shelf_plans_add_price_unsaved_data_discard_warning: "Your changes will discard. Do you want to continue?",
  personalAccident_shelf_plans_add_coverages_title: "Coverages",
  personalAccident_shelf_plans_add_services_title: "Services",
  personalAccident_shelf_plans_add_documents_title: "Documents",
  personalAccident_shelf_plans_add_requiredDocuments_title: "Required Documents",
  personalAccident_shelf_plans_add_requiredDocuments_listing_document_name: "Document Name",
  personalAccident_shelf_plans_add_requiredDocuments_listing_document_category: "Category",
  personalAccident_shelf_plans_add_requiredDocuments_listing_document_supportedFormats: "Supported Formats",
  personalAccident_shelf_plans_add_requiredDocuments_modal_name: "Document Name",
  personalAccident_shelf_plans_add_requiredDocuments_modal_name_required_error: "Document Name is required",
  personalAccident_shelf_plans_add_requiredDocuments_modal_name_length_error: "Document Name should be under 25 characters",
  personalAccident_shelf_plans_add_requiredDocuments_modal_name_empty_space_error: "Document Name is invalid",
  personalAccident_shelf_plans_add_requiredDocuments_modal_name_special_character_error:
    "Document Name should not contain special characters or numbers",
  personalAccident_shelf_plans_add_requiredDocuments_modal_category: "Category",
  personalAccident_shelf_plans_add_requiredDocuments_modal_category_placeholder: "Select Category",
  personalAccident_shelf_plans_add_requiredDocuments_modal_category_required_error: "Category is required",
  personalAccident_shelf_plans_add_requiredDocuments_modal_supported_format: "Supported Formats",
  personalAccident_shelf_plans_add_requiredDocuments_modal_supported_format_required_error: "Supported Format is required",

  personalAccident_shelf_plan_listing_add_documents_add_button: "Add Documents",
  personalAccident_shelf_plans_add_documents_documents_error: "Select documents is required",
  personalAccident_shelf_plans_add_documents_listing_document_name: "Document Name",
  personalAccident_shelf_plans_add_documents_select_documents: "Search document",
  personalAccident_shelf_plans_add_pre_existing_conditions_title: "Pre-Existing Conditions",
  personalAccident_shelf_plans_about_this_plan_title: "About This Plan",
  personalAccident_shelf_plans_add_about_this_plan_title: "About This Plan",
  personalAccident_shelf_plans_add_plan_exclusion_title: "Plan Exclusion",
  personalAccident_shelf_plans_add_coverages_coverages: "Select Coverages",
  personalAccident_shelf_plans_add_coverages_coverages_error: "Select Coverages is required",
  personalAccident_shelf_plans_add_coverages_description: "Description",
  personalAccident_shelf_plans_add_coverages_description_error: "Description is required",
  personalAccident_shelf_plans_add_coverages_benefit: "Benefit",
  personalAccident_shelf_plans_add_coverages_benefit_error: "Benefit is required",
  personalAccident_shelf_plans_add_coverages_description_error_max_length: "Description should be under 2000 characters",

  personalAccident_shelf_plans_add_plan_exclusion_exclusion: "Select Exclusion",
  personalAccident_shelf_plans_add_plan_exclusion_exclusion_error: "Exclusion is required",
  personalAccident_shelf_plans_add_plan_exclusion_description: "Description",
  personalAccident_shelf_plans_add_plan_exclusion_description_error: "Description is required",
  personalAccident_shelf_plans_add_plan_exclusion_benefit: "Benefit",
  personalAccident_shelf_plans_add_plan_exclusion_benefit_error: "Benefit is required",
  personalAccident_shelf_plans_add_plan_exclusion_description_error_max_length: "Description should be under 2000 characters",

  personalAccident_shelf_plans_add_info_renewal_age_title: "Renewals Only Age (In Yrs)",
  personalAccident_shelf_plans_add_info_plan_name: "Plan Name",
  personalAccident_shelf_plans_add_info_plan_name_required_error: "Plan name is required",
  personalAccident_shelf_plans_add_info_plan_name_length_error: "Plan name must be less than 30 characters",
  personalAccident_shelf_plans_add_info_product_name: "Product Name",
  personalAccident_shelf_plans_add_info_product_name_required_error: "Product name is required",
  personalAccident_shelf_plans_add_info_product_name_length_error: "Product name must be less than 30 characters",
  personalAccident_shelf_plans_add_info_plan_type: "Plan Type",
  personalAccident_shelf_plans_add_info_plan_type_required_error: "Plan type is required",
  personalAccident_shelf_plans_add_info_price_type: "Price Type",
  personalAccident_shelf_plans_add_info_price_type_required_error: "Price type is required",
  personalAccident_shelf_plans_add_info_line_of_business: "Line of Business",
  personalAccident_shelf_plans_add_info_free_service_title: "Free Service",
  personalAccident_shelf_plans_add_info_free_service_description: "Option to make the service available at no cost",
  personalAccident_shelf_plans_add_info_line_of_business_required_error: "Line of Business is required",
  personalAccident_shelf_plans_add_info_takaful_provider: "Takaful Provider",
  personalAccident_shelf_plans_add_info_takaful_provider_required_error: "Takaful provider is required",
  personalAccident_shelf_plans_add_info_sale_point: "Sale Point",
  personalAccident_shelf_plans_add_info_select_member: "Select Member",
  personalAccident_shelf_plans_view_info_member: "Members",
  personalAccident_shelf_plans_add_info_select_member_required_error: "Member is required",
  personalAccident_shelf_plans_add_info_select_gender: "Select Gender",
  personalAccident_shelf_plans_view_info_gender: "Gender",
  personalAccident_shelf_plans_add_info_select_gender_required_error: "Gender is required",
  personalAccident_shelf_plans_add_info_min_age: "Minimum Age",
  personalAccident_shelf_plans_add_info_min_age_min_error: "Minimum age must be positive",
  personalAccident_shelf_plans_add_info_min_age_max_error: "Minimum age must be lesser than 100",
  personalAccident_shelf_plans_add_info_min_age_required_error: "Minimum age is required",
  personalAccident_shelf_plans_add_info_max_age: "Maximum Age",
  personalAccident_shelf_plans_add_info_max_age_required_error: "Maximum age is required",
  personalAccident_shelf_plans_add_info_max_age_min_error: "Maximum age must be positive",
  personalAccident_shelf_plans_add_info_max_age_max_error: "Maximum age must be lesser than 100",
  personalAccident_shelf_plans_add_info_max_age_greater_than_min_age_error: "Maximum age must be greater than minimum age",

  personalAccident_shelf_plans_coverage_coverage_type: "Coverage Type",
  personalAccident_shelf_plans_coverage_benefit_value: "Benefit Value",
  personalAccident_shelf_plans_coverage_sub_child: "Sub-Child",

  personalAccident_shelf_plans_add_info_number_of_children: "No. of children",
  personalAccident_shelf_plans_add_info_number_of_children_required_error: "No. of children is required",
  personalAccident_shelf_plans_add_info_number_of_children_max_error: "No. of children must be lesser than or equal to 4",
  personalAccident_shelf_plans_add_info_number_of_children_min_error: "No. of children must be greater than 0",

  personalAccident_shelf_plans_listing_plan_exclusion_title: "Plan Exclusion",
  personalAccident_shelf_plans_listing_plan_exclusion_exclusion_type: "Exclusion Type",
  personalAccident_shelf_plans_listing_plan_exclusion_exclusion_value: "Exclusion Value",
  personalAccident_shelf_plans_listing_plan_exclusion_sub_child: "Sub-Child",

  personalAccident_shelf_plans_pre_existing_conditions_listing_title: "Pre-Existing Conditions",
  personalAccident_shelf_plans_pre_existing_conditions_listing_add: "Add PEC",
  personalAccident_shelf_plans_pre_existing_conditions_listing_year_range: "Year Range",
  personalAccident_shelf_plans_pre_existing_conditions_listing_condition: "Condition (%)",
  personalAccident_shelf_plans_pre_existing_conditions_listing_description: "Description",
  personalAccident_shelf_plans_pre_existing_conditions_add_title: "Pre-Existing Conditions",
  personalAccident_shelf_plans_pre_existing_conditions_add_year_range: "Year Range",
  personalAccident_shelf_plans_pre_existing_conditions_add_year_range_min_error: "Date Range (Min) is required",
  personalAccident_shelf_plans_pre_existing_conditions_add_year_range_min_error_min_limit: "Date Range (Min) can't be less than 1",
  personalAccident_shelf_plans_pre_existing_conditions_add_year_range_max_error_min_limit: "Date Range (Max) can't be less than 1",
  personalAccident_shelf_plans_pre_existing_conditions_add_year_range_min_error_min_year_limit: "Date Range (Min) can't be more than 1 digit",
  personalAccident_shelf_plans_pre_existing_conditions_add_year_range_min_error_more_than_two: "Date Range (Min) can't be more than 2 digit",
  personalAccident_shelf_plans_pre_existing_conditions_add_year_range_max_error_max_year_limit: "Date Range (Max) can't be more than 2 digit",
  personalAccident_shelf_plans_pre_existing_conditions_add_year_range_min_error_max_days_limit: "Date Range (Min) can't be more than 365",
  personalAccident_shelf_plans_pre_existing_conditions_add_year_range_max_error_max_days_limit: "Date Range (Max) can't be more than 365",
  personalAccident_shelf_plans_pre_existing_conditions_add_year_range_min_error_decimal: "Date Range (Min) can't be decimal",
  personalAccident_shelf_plans_pre_existing_conditions_add_year_range_max_error_decimal: "Date Range (Max) can't be decimal",
  personalAccident_shelf_plans_pre_existing_conditions_add_year_range_max_error_min_year_and_max_day:
    "Date Range (Max) can't be days if Date Range (Min) is year",
  personalAccident_shelf_plans_pre_existing_conditions_add_year_range_max_error: "Date Range (Max) is required",
  personalAccident_shelf_plans_pre_existing_conditions_add_year_range_min_error_greater_than_year_range_max:
    "Date Range (Min) should be less than Date Range (Max)",
  personalAccident_shelf_plans_pre_existing_conditions_add_year_condition: "Condition",
  personalAccident_shelf_plans_pre_existing_conditions_add_year_condition_error: "Condition is required",
  personalAccident_shelf_plans_pre_existing_conditions_add_condition_error_min_limit: "Condition can't be less than 0",
  personalAccident_shelf_plans_pre_existing_conditions_add_condition_error_max_percentage_limit: "Condition can't be greater than 100",
  personalAccident_shelf_plans_pre_existing_conditions_add_condition_error_decimal: "Condition can't be decimal",
  personalAccident_shelf_plans_pre_existing_conditions_add_year_description: "Description",
  personalAccident_shelf_plans_pre_existing_conditions_add_year_description_error_max_length: "Description should be under 250 characters",
  personalAccident_shelf_plans_add_price_setup_annual_pricing_title: "Annual Pricing",
  personalAccident_shelf_plans_add_price_setup_monthly_pricing_title: "Monthly Pricing",
  personalAccident_shelf_plans_add_price_setup_incentive_title: "Incentive",
  personalAccident_shelf_plans_add_price_setup_incentive_min: "Incentive(Min)",
  personalAccident_shelf_plans_add_price_setup_incentive_max: "Incentive(Max)",
  personalAccident_shelf_plans_add_price_setup_built_in_incentive: "Built-in Incentive",
  personalAccident_shelf_plans_add_price_setup_base_rate: "Base Rate",
  personalAccident_shelf_plans_add_price_setup_one_month_installment_range: "1 Month Installment Range",
  personalAccident_shelf_plans_add_price_setup_eleven_month_installment_range: "11 Month Installment Range",
  personalAccident_shelf_plans_add_price_setup_admin_cost_title: "Admin Cost",
  personalAccident_shelf_plans_add_price_setup_pricing_title: "Pricing",
  personalAccident_shelf_plans_add_price_setup_add_row: "Add Row",
  personalAccident_shelf_plans_add_price_setup_listing_age_bracket: "Age Bracket",
  personalAccident_shelf_plans_add_price_setup_listing_listing_price: "Listing Price",
  personalAccident_shelf_plans_add_price_setup_listing_total_admin_and_taxes: "Total Admin & Taxes",
  personalAccident_shelf_plans_add_price_setup_listing_gross_contribution: "Gross Contribution",
  personalAccident_shelf_plans_add_price_setup_listing_incentive_range: "Incentive Range",
  personalAccident_shelf_plans_add_price_setup_listing_selling_price_range: "Selling Price Range",

  personalAccident_shelf_plans_add_price_setup_incentive_min_required_error: "Minimum-Incentive is required",
  personalAccident_shelf_plans_add_price_setup_incentive_min_maximum_error_in_percentage:
    "Minimum-Incentive must be equal to or less than two digits",
  personalAccident_shelf_plans_add_price_setup_incentive_min_minimum_error_in_percentage: "Minimum-Incentive must be positive",
  personalAccident_shelf_plans_add_price_setup_incentive_min_minimum_decimal_error_in_percentage:
    "Minimum-Incentive must not contain more than 2 decimal points",
  personalAccident_shelf_plans_add_price_setup_incentive_min_maximum_error_in_non_percentage:
    "Minimum-Incentive must be equal to or less than five digits",
  personalAccident_shelf_plans_add_price_setup_incentive_min_decimal_error_in_non_percentage: "Minimum-Incentive must not contain decimal points",

  personalAccident_shelf_plans_add_price_setup_incentive_max_required_error: "Maximum-Incentive is required",
  personalAccident_shelf_plans_add_price_setup_incentive_max_minimum_error_in_percentage: "Maximum-Incentive must be positive",
  personalAccident_shelf_plans_add_price_setup_incentive_max_maximum_error_in_percentage:
    "Maximum-Incentive must be equal to or less than two digits",
  personalAccident_shelf_plans_add_price_setup_incentive_max_minimum_decimal_error_in_percentage:
    "Maximum-Incentive must contain only 2 decimal points",
  personalAccident_shelf_plans_add_price_setup_incentive_max_decimal_error_in_non_percentage: "Maximum-Incentive must contain only 2 decimal points",
  personalAccident_shelf_plans_add_price_setup_incentive_max_maximum_error_in_non_percentage:
    "Maximum-Incentive must be equal to or less than five digits",
  personalAccident_shelf_plans_add_price_setup_incentive_max_greater_than_min_error:
    "Maximum-Incentive must be equal to or greater than  Minimum-Incentive",
  personalAccident_shelf_plans_add_price_setup_incentive_max_value_type_id_different_from_incentive_min_type_id_err:
    "Maximum-Incentive Provision type must be same as Minimum-Incentive Provision type",
  personalAccident_shelf_plans_add_price_setup_provision_type_required_error: "Provision type is required",
  personalAccident_shelf_plans_add_price_setup_incentive_max_value_different_from_incentive_min_value_in_digital_sell_point_err:
    "Maximum-Incentive must be equal to Minimum-Incentive in Digital Sell Point",

  personalAccident_shelf_plans_add_price_setup_incentive_built_in_required_error: "Built-In Incentive is required",
  personalAccident_shelf_plans_add_price_setup_incentive_built_in_maximum_error_in_percentage:
    "Built-In Incentive  must be must be equal to or less than two digits",
  personalAccident_shelf_plans_add_price_setup_incentive_built_in_minimum_decimal_error_in_percentage:
    "Built-In Incentive must be contain only 2 decimal points",
  personalAccident_shelf_plans_add_price_setup_incentive_built_in_maximum_error_in_non_percentage:
    "Built-In Incentive must be equal to or less than Six digits",
  personalAccident_shelf_plans_add_price_setup_incentive_built_in_decimal_error_in_non_percentage:
    "Built-In Incentive must contain two decimal points",
  personalAccident_shelf_plans_add_price_setup_incentive_built_in_minimum_error_in_percentage: "Built-In Incentive must be positive",

  personalAccident_shelf_plans_add_price_setup_min_admin_cost_required_error: "Minimum Admin Cost is required",
  personalAccident_shelf_plans_add_price_setup_min_admin_cost_minimum_error_in_percentage: "Minimum Admin Cost must be positive",
  personalAccident_shelf_plans_add_price_setup_min_admin_cost_maximum_error_in_percentage:
    "Minimum Admin Cost must be must be equal to or less than two digits",
  personalAccident_shelf_plans_add_price_setup_min_admin_cost_minimum_decimal_error_in_percentage:
    "Minimum Admin cost can be contain 2 decimal points",
  personalAccident_shelf_plans_add_price_setup_min_admin_cost_maximum_error_in_non_percentage:
    "Minimum Admin Cost must be equal to or less than Five digits",
  personalAccident_shelf_plans_add_price_setup_min_admin_cost_decimal_error_in_non_percentage: "Minimum Admin Cost must contain two decimals",

  personalAccident_shelf_plans_add_price_setup_max_admin_cost_required_error: "Maximum Admin Cost is required",
  personalAccident_shelf_plans_add_price_setup_max_admin_cost_minimum_error_in_percentage: "Maximum Admin Cost must be positive",
  personalAccident_shelf_plans_add_price_setup_max_admin_cost_maximum_error_in_percentage:
    "Maximum Admin Cost must be must be equal to or less than two digits",
  personalAccident_shelf_plans_add_price_setup_max_admin_cost_minimum_decimal_error_in_percentage:
    "Maximum Admin cost can be contain 2 decimal points",
  personalAccident_shelf_plans_add_price_setup_max_admin_cost_maximum_error_in_non_percentage:
    "Maximum Admin Cost must be equal to or less than Five digits",
  personalAccident_shelf_plans_add_price_setup_max_admin_cost_decimal_error_in_non_percentage:
    "Maximum Admin Cost must not contain more than two decimals",
  personalAccident_shelf_plans_add_price_setup_max_admin_cost_value_type_id_different_from_min_admin_cost_value_type_id_err:
    "Maximum Admin Cost Provision type must be same as Minimum Admin Cost Provision type",
  personalAccident_shelf_plans_add_price_setup_max_admin_cost_greater_than_min_error:
    "Maximum Admin Cost must be equal to or greater than  Minimum Admin Cost",

  personalAccident_shelf_plans_add_price_setup_grid_min_age_required_error: "Minimum Age is required",
  personalAccident_shelf_plans_add_price_setup_grid_duration_type_required_error: "Duration type is required",
  personalAccident_shelf_plans_add_price_setup_grid_min_age_minimum_error_in_year: "Minimum Age must be positive",
  personalAccident_shelf_plans_add_price_setup_grid_min_age_maximum_error_in_year: "Minimum Age must be must be equal to or less than two digits",
  personalAccident_shelf_plans_add_price_setup_grid_min_age_decimal_error: "Minimum Age must not contain decimal",
  personalAccident_shelf_plans_add_price_setup_min_age_maximum_digits_error_in_days: "Minimum Age must be equal to or less than Three digits",
  personalAccident_shelf_plans_add_price_setup_min_age_maximum_value_error_in_days: "Minimum Age must be equal to or less than 365",

  personalAccident_shelf_plans_add_price_setup_grid_max_age_required_error: "Maximum Age is required",
  personalAccident_shelf_plans_add_price_setup_grid_max_age_minimum_error_in_year: "Maximum Age must be positive",
  personalAccident_shelf_plans_add_price_setup_grid_max_age_decimal_error: "Maximum Age must not contain decimal",
  personalAccident_shelf_plans_add_price_setup_grid_max_age_maximum_error_in_year: "Maximum Age must be must be equal to or less than two digits",
  personalAccident_shelf_plans_add_price_setup_max_age_maximum_digits_error_in_days: "Maximum Age must be equal to or less than Three digits",
  personalAccident_shelf_plans_add_price_setup_max_age_maximum_value_error_in_days: "Maximum Age must be equal to or less than 365",
  personalAccident_shelf_plans_add_price_setup_max_age_range_conflict_error: "This Age Range is conflicting",

  personalAccident_shelf_plans_add_price_setup_max_age_value_type_id_different_from_min_age_value_type_id_err:
    "Maximum Age Duration type must be same as Minimum Age Duration type",
  personalAccident_shelf_plans_add_price_setup_max_age_greater_than_min_error: "Maximum Age must be equal to or greater than  Minimum Age",

  personalAccident_shelf_plans_add_price_setup_grid_listing_price_required_error: "Listing Price is required",
  personalAccident_shelf_plans_add_price_setup_grid_listing_price_minimum_error: "Listing Price must be positive",
  personalAccident_shelf_plans_add_price_setup_grid_listing_price_maximum_error_in_percentage:
    "Listing Price must be equal to or less than two digits",
  personalAccident_shelf_plans_add_price_setup_grid_listing_price_minimum_decimal_error_in_percentage: "Listing Price must be contain decimal points",
  personalAccident_shelf_plans_add_price_setup_grid_listing_price_maximum_error_in_non_percentage:
    "Listing Price must be equal to or less than Six digits",

  personalAccident_shelf_plans_sale_point: "Sale Point",
  personalAccident_shelf_plans_select_sale_point: "Select Salepoint",
  personalAccident_shelf_plans_select_sale_point_error: "Please select salePoint",

  personalAccident_shelf_plans_services_listing_title: "Services",
  personalAccident_shelf_plans_services_listing_priority_order: "Priority Order",
  personalAccident_shelf_plans_services_listing_service_name: "Service Name",
  personalAccident_shelf_plans_services_listing_provider_name: "Provider Name",
  personalAccident_shelf_plans_services_listing_sub_services: "Sub-Services",

  personalAccident_order_listing_title: "personalAccident Orders",
  personalAccident_order_download_as_zip: "Download as ZIP",
  personalAccident_order_download_export_to_excel: "Export to Excel",
  personalAccident_order_listing_order_date: "Order Date",
  personalAccident_order_listing_order_id: "Order Id",
  personalAccident_order_listing_name: "Name",
  personalAccident_order_listing_sale_point: "Sale Point",
  personalAccident_order_listing_plan_name: "Plan Name",
  personalAccident_order_listing_plan_type: "Plan Type",
  personalAccident_order_listing_contribution: "Contribution",
  personalAccident_order_listing_payment_frequency: "Payment Frequency",
  personalAccident_order_listing_source: "Source",
  personalAccident_order_listing_payment_status: "Payment Status",
  personalAccident_order_listing_policy_status: "Policy Status",
  personalAccident_order_listing_policy_id: "Policy ID",
  personalAccident_order_listing_takaful_provider: "Takaful Provider",
  personalAccident_order_listing_services_provider: "Services Provider",
  personalAccident_order_listing_services: "Services",
  personalAccident_order_listing_product_name: "Product Name",
  personalAccident_order_listing_policy_issue_date: "Policy Issue Date",
  personalAccident_order_listing_policy_expiry_date: "Policy Expiry Date",
  personalAccident_order_listing_last_updated: "Last Updated",
  personalAccident_order_personal_details: "Personal Details",
  personalAccident_order_proposer_details: "Proposer Details",
  personalAccident_order_proposer_details_title: "Proposer Details",
  personalAccident_order_member_details: "Member Details",
  personalAccident_order_plan_details: "Plan Details",
  personalAccident_order_documents: "Documents",
  personalAccident_order_payment: "Payment",
  personalAccident_order_activity_log: "Activity Log",
  personalAccident_order_customer_details: "Customer Details",
  personalAccident_order_proposer_details_edit: "Edit",
  personalAccident_order_name: "Name",
  personalAccident_order_date_of_birth: "Date of Birth",
  personalAccident_order_place_of_birth: "Place of Birth",
  personalAccident_order_cnic_number: "CNIC Number",
  personalAccident_order_cnic_issue_date: "CNIC Issue Date",
  personalAccident_order_cnic_expiry_date: "CNIC Expiry Date",
  personalAccident_order_cnic_marital_status: "Marital Status",
  personalAccident_order_occupation: "Occupation",
  personalAccident_order_contact_details: "Contact Details",
  personalAccident_order_contact_number: "Contact Number",
  personalAccident_order_email_address: "Email Address",
  personalAccident_order_address: "Address",
  personalAccident_order_permanent_address: "Permanent Address",
  personalAccident_order_current_address: "Current Address",
  personalAccident_order_city: "City",
  personalAccident_order_name_error: "Name is required",
  personalAccident_order_name_validation_error: "Invalid Name",
  personalAccident_order_name_length_error: "Name must be smaller than 35 characters",
  personalAccident_order_date_of_birth_error: "Date of Birth is required",
  personalAccident_order_cnic_error: "CNIC is required",
  personalAccident_order_cnic_length_error: "CNIC Number should be 13 digits only",
  personalAccident_order_cnic_issue_date_error: "CNIC issue date is required",
  personalAccident_order_cnic_expiry_date_error: "CNIC expiry date is required",
  personalAccident_order_cnic_issue_date_before_expiry_date_error: "CNIC Issue date should be before expiry date",
  personalAccident_order_cnic_issue_date_five_year_before_expiry_date_error: "CNIC Expiry date should be at least 5 years after CNIC issue date",
  personalAccident_order_date_of_birth_before_cnic_issue_date_error: "Date of birth should be before CNIC issue date",
  personalAccident_order_cnic_issue_date_eighteen_year_before_cnic_issue_date_error:
    "CNIC Issue date should be at least 18 years after date of birth",
  personalAccident_order_cnic_cnic_life_time_expiry: "Lifetime",
  personalAccident_order_cnic_validation_error: "Incorrect format i.e 12345-4567896-6",
  personalAccident_order_cnic_number_placeholder: "12345-4567896-6",
  personalAccident_order_marital_status_error: "Martial status is required",
  personalAccident_order_occupation_error: "Occupation is required",
  personalAccident_order_occupation_length_error: "Occupation must be smaller than 35 characters",
  personalAccident_order_contact_number_error: "Contact number is required",
  personalAccident_order_email_error: "Email Address is required",
  personalAccident_order_email_validation: "Invalid Email",
  personalAccident_order_permanent_address_error: "Permanent Address is required",
  personalAccident_order_current_address_error: "Current Address is required",
  personalAccident_order_permanent_address_length_error: "Permanent Address must be smaller than 100 characters",
  personalAccident_order_current_address_length_error: "Current Address must be smaller than 100 characters",
  personalAccident_order_city_error: "City is required",
  personalAccident_order_same_as_permanent_address: "Same as permanent address",
  personalAccident_order_occupation_validation_error: "Invalid Occupation",
  personalAccident_order_holder_of_any_government_office: "Holder of any Government Office",
  personalAccident_order_life_time: "Life time",
  personalAccident_order_edit_holder_of_any_government_office: "Holder of any Government Office",

  personalAccident_order_member_details_edit: "Edit",
  personalAccident_order_spouse_details: "Spouse Details",
  personalAccident_order_full_name: "Full Name",
  personalAccident_order_child_details: "Child Details",
  personalAccident_order_child: "Child",
  personalAccident_order_relation: "Relation",
  personalAccident_order_relation_error: "Relation is required",
  personalAccident_order_child_name_error: "Child name is required",
  personalAccident_order_child_name_validation_error: "Invalid Child Name",
  personalAccident_order_child_date_of_birth_error: "Child Date of Birth is required",
  personalAccident_order_child_relation_error: "Child relation is required",
  personalAccident_order_child_name_length_error: "Child name must be smaller than 35 characters",
  personalAccident_order_member_details_father_details: "Father Details",
  personalAccident_order_member_details_mother_details: "Mother Details",
  personalAccident_order_edit_member_details_father_details: "Father Details",
  personalAccident_order_edit_member_details_mother_details: "Mother Details",

  personalAccident_order_plan_details_takaful_provider_details: "Takaful Provider Details",
  personalAccident_order_plan_details_takaful_provider_name: "Takaful Provider Name",
  personalAccident_order_plan_details_plan_name: "Plan Name",
  personalAccident_order_plan_details_product_name: "Product Name",
  personalAccident_order_plan_details_policy_id: "Policy ID",
  personalAccident_order_plan_details_policy_issue_date: "Policy Issue Date",
  personalAccident_order_plan_details_policy_expiry_date: "Policy Expiry Date",
  personalAccident_order_plan_details_services: "Services",
  personalAccident_order_plan_details_med_iq: "Med IQ",
  personalAccident_order_plan_details_service_provider_2: "Service Provider 2",
  personalAccident_order_plan_details_service_provider_3: "Service Provider 3",
  personalAccident_order_plan_details_payment: "Payment",
  personalAccident_order_plan_details_payment_frequency: "Payment Frequency",
  personalAccident_order_plan_details_total_contribution: "Total Contribution",
  personalAccident_order_plan_details_1st_month_installment: "1st Month Installment",
  personalAccident_order_plan_details_11_months_installment: "11 Months Installment",
  personalAccident_order_plan_details_service_provider: "Service Provider",
  personalAccident_order_plan_details_price: "Price",
  personalAccident_order_plan_details_service: "Service",

  personalAccident_order_documents_title: "Documents",
  personalAccident_order_download_all_as_zip: "Download all as ZIP",
  personalAccident_order_upload_documents: "Uploaded Document",
  personalAccident_order_upload_type: "Document Type",
  personalAccident_order_last_updated: "Last Updated",
  personalAccident_order_non_editable_document: "Cannot Edit _DOCUMENT_TYPE_",

  personalAccident_order_edit_documents_name: "Document Name",
  personalAccident_order_edit_documents_name_error: "Document name is required",
  personalAccident_order_edit_documents_name_length_error: "Document name must be smaller than 50 characters",

  personalAccident_order_edit_documents_policy_id: "Policy ID",
  personalAccident_order_edit_documents_policy_id_error: "Policy id is required",
  personalAccident_order_edit_documents_policy_issue_date: "Policy Issue Date",
  personalAccident_order_edit_documents_policy_expiry_date: "Policy Expiry Date",
  personalAccident_order_edit_documents_policy_issue_date_error: "CNIC issue date is required",
  personalAccident_order_edit_documents_policy_expiry_date_error: "CNIC expiry date is required",
  personalAccident_order_edit_documents_policy_id_length_error: "Policy id must be smaller than 20 characters",
  personalAccident_order_edit_documents_policy_id_validation_error: "Special characters are not allowed",

  personalAccident_order_edit_documents_doc_type: "Documents Type",
  personalAccident_order_edit_documents_doc_type_error: "Document type is required",
  personalAccident_order_add_documents_upload_error: "Upload document is required",
  personalAccident_order_add_documents_upload_document: "Upload Document",
  personalAccident_order_add_documents_upload_text: "Upload",
  personalAccident_order_add_documents_last_updated_text: "Last Updated",

  personalAccident_order_payment_title: "Payment",
  personalAccident_order_payment_month: "Month",
  personalAccident_order_payment_method: "Payment Method",
  personalAccident_order_payment_status: "Payment Status",
  personalAccident_order_payment_contribution: "Contribution",
  personalAccident_order_payment_payment_status: "Payment Status",
  personalAccident_order_payment_last_updated: "Last Updated",
  personalAccident_order_payment_period: "Period",

  personalAccident_order_edit_payment_title: "Payment",
  personalAccident_order_edit_payment_error: "Payment is required",

  personalAccident_order_view_payment_title: "Payment",
  personalAccident_order_view_payment_details_title: "Payment Details",
  personalAccident_order_view_payment_details_total_contribution: "Total Contribution",
  personalAccident_order_view_payment_details_frequency: "Frequency",
  personalAccident_order_view_payment_details_payment_method: "Payment Method",
  personalAccident_order_view_payment_services_title: "Services",
  personalAccident_order_view_payment_med_iq: "Med IQ",
  personalAccident_order_view_payment_provider_2: "Provider 2",

  personalAccident_order_view_payment_contact_details_title: "Contact Details",
  personalAccident_order_view_payment_pick_up_address: "Pick Up Address",
  personalAccident_order_view_payment_contact_number: "Contact Number",

  personalAccident_order_view_payment_status_title: "Payment Status",
  personalAccident_order_view_payment_month: "Month",
  personalAccident_order_view_payment_amount: "Amount",
  personalAccident_order_view_payment_status: "Status",

  personalAccident_order_activity_log_heading: "Activity log",
  personalAccident_shelf_plans_edit_service_annual_pricing_title: "Annual Pricing",
  personalAccident_shelf_plans_edit_service_monthly_pricing_title: "Monthly Pricing",
  personalAccident_shelf_plans_edit_service_incentive_title: "Incentive",
  personalAccident_shelf_plans_edit_service_incentive_min: "Incentive(Min)",
  personalAccident_shelf_plans_edit_service_incentive_max: "Incentive(Max)",
  personalAccident_shelf_plans_edit_service_built_in_incentive: "Built-in Incentive",
  personalAccident_shelf_plans_edit_service_base_rate: "Base Rate",
  personalAccident_shelf_plans_edit_service_one_month_installment_range: "1 Month Installment Range",
  personalAccident_shelf_plans_edit_service_eleven_month_installment_range: "11 Month Installment Range",
  personalAccident_shelf_plans_edit_service_admin_cost_title: "Admin Cost",
  personalAccident_shelf_plans_edit_service_pricing_title: "Pricing",
  personalAccident_shelf_plans_edit_service_add_row: "Add Row",
  personalAccident_shelf_plans_edit_service_listing_age_bracket: "Age Bracket",
  personalAccident_shelf_plans_edit_service_listing_listing_price: "Listing Price",
  personalAccident_shelf_plans_edit_service_listing_total_admin_and_taxes: "Total Admin & Taxes",
  personalAccident_shelf_plans_edit_service_listing_gross_contribution: "Gross Contribution",
  personalAccident_shelf_plans_edit_service_listing_incentive_range: "Incentive Range",
  personalAccident_shelf_plans_edit_service_listing_selling_price_range: "Selling Price Range",

  personalAccident_shelf_plans_edit_service_incentive_min_required_error: "Input field is required",
  personalAccident_shelf_plans_edit_service_incentive_min_maximum_error_in_percentage: "Minimum-Incentive must be equal to or less than two digits",
  personalAccident_shelf_plans_edit_service_incentive_min_minimum_error_in_percentage: "Negative Values are not allowed",
  personalAccident_shelf_plans_edit_service_incentive_min_minimum_decimal_error_in_percentage: "Minimum-Incentive must contain only 2 decimal points",
  personalAccident_shelf_plans_edit_service_incentive_min_maximum_error_in_non_percentage:
    "Minimum-Incentive must be equal to or less than five digits",
  personalAccident_shelf_plans_edit_service_incentive_min_decimal_error_in_non_percentage: "Must be equal or less than two decimals ",

  personalAccident_shelf_plans_edit_service_incentive_max_required_error: "Input field is required",
  personalAccident_shelf_plans_edit_service_incentive_max_minimum_error_in_percentage: "Negative Values are not allowed",
  personalAccident_shelf_plans_edit_service_incentive_max_maximum_error_in_percentage: "Maximum-Incentive must be equal to or less than two digits",
  personalAccident_shelf_plans_edit_service_incentive_max_minimum_decimal_error_in_percentage:
    "Maximum-Incentive must be contain only 2 decimal points",
  personalAccident_shelf_plans_edit_service_incentive_max_decimal_error_in_non_percentage: "Must contain only 2 decimal points",
  personalAccident_shelf_plans_edit_service_incentive_max_maximum_error_in_non_percentage:
    "Maximum-Incentive must be equal to or less than five digits",
  personalAccident_shelf_plans_edit_service_incentive_max_greater_than_min_error:
    "Maximum-Incentive must be equal to or greater than  Minimum-Incentive",
  personalAccident_shelf_plans_edit_service_incentive_max_value_type_id_different_from_incentive_min_type_id_err:
    "Maximum-Incentive Provision type must be same as Minimum-Incentive Provision type",
  personalAccident_shelf_plans_edit_service_incentive_max_value_different_from_incentive_min_value_in_digital_sell_point_err:
    "Maximum-Incentive must be equal to Minimum-Incentive in Digital Sell Point",

  personalAccident_shelf_plans_edit_service_incentive_built_in_required_error: "Input field is required",
  personalAccident_shelf_plans_edit_service_incentive_built_in_maximum_error_in_percentage:
    "Built-In Incentive  must be must be equal to or less than two digits",
  personalAccident_shelf_plans_edit_service_incentive_built_in_minimum_decimal_error_in_percentage:
    "Built-In Incentive must be contain only 2 decimal points",
  personalAccident_shelf_plans_edit_service_incentive_built_in_maximum_error_in_non_percentage:
    "Built-In Incentive must be equal to or less than Six digits",
  personalAccident_shelf_plans_edit_service_incentive_built_in_decimal_error_in_non_percentage: "Must be equal or less than two decimals",
  personalAccident_shelf_plans_edit_service_incentive_built_in_minimum_error_in_percentage: "Negative Values are not allowed",

  personalAccident_shelf_plans_edit_service_min_admin_cost_required_error: "Input field is required",
  personalAccident_shelf_plans_edit_service_min_admin_cost_minimum_error_in_percentage: "Negative Values are not allowed",
  personalAccident_shelf_plans_edit_service_min_admin_cost_maximum_error_in_percentage:
    "Minimum Admin Cost must be must be equal to or less than two digits",
  personalAccident_shelf_plans_edit_service_min_admin_cost_minimum_decimal_error_in_percentage: "Minimum Admin cost can be contain 2 decimal points",
  personalAccident_shelf_plans_edit_service_min_admin_cost_maximum_error_in_non_percentage:
    "Minimum Admin Cost must be equal to or less than Five digits",
  personalAccident_shelf_plans_edit_service_min_admin_cost_decimal_error_in_non_percentage: "Must be equal or less than two decimals ",

  personalAccident_shelf_plans_edit_service_max_admin_cost_required_error: "Input field is required",
  personalAccident_shelf_plans_edit_service_max_admin_cost_minimum_error_in_percentage: "Negative Values are not allowed",
  personalAccident_shelf_plans_edit_service_max_admin_cost_maximum_error_in_percentage:
    "Maximum Admin Cost must be must be equal to or less than two digits",
  personalAccident_shelf_plans_edit_service_max_admin_cost_minimum_decimal_error_in_percentage: "Maximum Admin cost can be contain 2 decimal points",
  personalAccident_shelf_plans_edit_service_max_admin_cost_maximum_error_in_non_percentage:
    "Maximum Admin Cost must be equal to or less than Five digits",
  personalAccident_shelf_plans_edit_service_max_admin_cost_decimal_error_in_non_percentage: "Must be equal or less than two decimals ",
  personalAccident_shelf_plans_edit_service_max_admin_cost_value_type_id_different_from_min_admin_cost_value_type_id_err:
    "Maximum Admin Cost Provision type must be same as Minimum Admin Cost Provision type",
  personalAccident_shelf_plans_edit_service_max_admin_cost_greater_than_min_error:
    "Maximum Admin Cost must be equal to or greater than  Minimum Admin Cost",

  personalAccident_shelf_plans_edit_service_grid_min_age_required_error: "Input field is required",
  personalAccident_shelf_plans_edit_service_grid_min_age_minimum_error_in_year: "Negative values are not allowed",
  personalAccident_shelf_plans_edit_service_grid_min_age_maximum_error_in_year: "Minimum Age must be must be equal to or less than two digits",
  personalAccident_shelf_plans_edit_service_grid_min_age_decimal_error: "Decimal values are not allowed",
  personalAccident_shelf_plans_edit_service_min_age_maximum_digits_error_in_days: "Minimum Age must be equal to or less than Three digits",
  personalAccident_shelf_plans_edit_service_min_age_maximum_value_error_in_days: "Minimum Age must be equal to or less than 365",

  personalAccident_shelf_plans_edit_service_grid_max_age_required_error: "Input field is required",
  personalAccident_shelf_plans_edit_service_grid_max_age_minimum_error_in_year: "Negative values are not allowed",
  personalAccident_shelf_plans_edit_service_grid_max_age_decimal_error: "Decimal values are not allowed",
  personalAccident_shelf_plans_edit_service_grid_max_age_maximum_error_in_year: "Maximum Age must be must be equal to or less than two digits",
  personalAccident_shelf_plans_edit_service_max_age_maximum_digits_error_in_days: "Maximum Age must be equal to or less than Three digits",
  personalAccident_shelf_plans_edit_service_max_age_maximum_value_error_in_days: "Maximum Age must be equal to or less than 365",
  personalAccident_shelf_plans_edit_service_max_age_value_type_id_different_from_min_age_value_type_id_err:
    "Maximum Age Duration type must be same as Minimum Age Duration type",
  personalAccident_shelf_plans_edit_service_max_age_greater_than_min_error: "Maximum Age must be equal to or greater than  Minimum Age",
  personalAccident_shelf_plans_edit_service_max_age_duration_not_same_min_age_duration_error_in_days:
    "Maximum Age duration type must be same as Minimum age duration type",

  personalAccident_shelf_plans_edit_service_max_age_range_conflict_error: "Duplicate entry",

  personalAccident_shelf_plans_edit_service_grid_listing_price_required_error: "Input field is required",
  personalAccident_shelf_plans_edit_service_grid_listing_price_minimum_error: "Negative values are not allowed",
  personalAccident_shelf_plans_edit_service_grid_listing_price_maximum_error_in_percentage: "Listing Price must be equal to or less than two digits",
  personalAccident_shelf_plans_edit_service_grid_listing_price_minimum_decimal_error_in_percentage: "Listing Price must not contain decimals",
  personalAccident_shelf_plans_edit_service_grid_listing_price_maximum_error_in_non_percentage:
    "Listing Price must be equal to or less than seven digits",
  personalAccident_shelf_plans_edit_service_grid_listing_price_decimal_error_in_non_percentage: "Decimal values are not allowed",
  management_service_add_price_setup_max_age_range_conflict_error: "Duplicate Entry",

  personalAccident_shelf_plans_edit_service_duration_type_required_error: "Duration type is required",
  personalAccident_shelf_plans_edit_service_provision_type_required_error: "Provision type is required",

  personalAccident_shelf_plans_add_service_select_provider: "Select Provider",
  personalAccident_shelf_plans_add_service_select_provider_required_error: "Select Provider is required",
  personalAccident_shelf_plans_add_service_select_provider_takaful_provider: "Takaful Provider",
  personalAccident_shelf_plans_add_service_select_provider_service_provider: "Service Provider",
  personalAccident_shelf_plans_add_service_search_service: "Search Service",
  personalAccident_shelf_plans_add_service_search_service_required_error: "Search Service is required",
  personalAccident_shelf_plans_add_service_service_heading: "Service",
  personalAccident_shelf_plans_add_service_sub_service_heading: "Sub Service",
  personalAccident_shelf_plans_add_service_title: "Add Service",

  personal_accident_order_listing_title: "Personal Accident"
};
